// extracted by mini-css-extract-plugin
module.exports = {"bankIDPersonalNumber":"styles_bankIDPersonalNumber__2fUZB","logo":"styles_logo__DzIcd","button":"styles_button__2cvFS"};